import {
	LoginPage,
	SignUpPage,
	PaymentPage,
	WelcomePage,
	BrandSetupPage,
	BrandsListsPage,
	ProjectsListsPage,
	CreativeFormPostPage,
	TextAndButtonPostPage,
	ProductAndServiceImagesPage,
	GeneratedPostsPage,
	SettingsPage,
	PackagesPage,
} from './pages'

import './style/main.scss'
import { Redirect, Route, Switch } from 'react-router-dom'
import { HowDoesItWorkPage } from './pages/HowDoesItWorkPage'

const App: React.FC = () => {
	return (
		<div>
			<Switch>
				<Redirect exact from='/' to='/login' />
				<Route exact path='/login' component={LoginPage} />
				<Route exact path='/signup' component={SignUpPage} />
				<Route exact path='/payment' component={PaymentPage} />
			</Switch>
			<Switch>
				<Route exact path='/welcome' component={WelcomePage} />
				<Route exact path='/brandsetup' component={BrandSetupPage} />
				<Route exact path='/brandslists' component={BrandsListsPage} />
				<Route exact path='/projectslists' component={ProjectsListsPage} />
				<Route
					exact
					path='/creativeformpost'
					component={CreativeFormPostPage}
				/>
				<Route
					exact
					path='/textandbuttonpost'
					component={TextAndButtonPostPage}
				/>
				<Route
					exact
					path='/productandserviceimages'
					component={ProductAndServiceImagesPage}
				/>
				<Route exact path='/generatedposts' component={GeneratedPostsPage} />
				<Route exact path='/settings' component={SettingsPage} />
				<Route exact path='/packages' component={PackagesPage} />
				<Route exact path='/howdoesitwork' component={HowDoesItWorkPage} />
			</Switch>
		</div>
	)
}

export default App
